export default "__VITE_ASSET__InovRf1p__"